<template>
  <nav class=" cor-primaria-bg">
    <div class="container nav-wrapper  ">
      <router-link :to="link" replace class="left">
        <i style="margin-left: 8px" class="material-icons md-30">arrow_back</i>
      </router-link>
      <span style="padding-left: 15px; font-weight: bold">{{titulo}}</span>
      <language-selector class="right" style="margin-top: 2px; margin-right: 8px;" />
    </div>
  </nav>
</template>

<script>
import LanguageSelector from "../LanguageSelector.vue";

export default {
  name: "MenuSuperior",
  components: {
    LanguageSelector
  },
  data(){
    return{
      drawer:false
    }
  },
  props: ["link", "titulo"]
};
</script>



// WEBPACK FOOTER //
// src/components/Widgets/MenuSuperior.vue